import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from '@angular/common';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';

@Pipe ({
	name: 'formattedNumber'
})
export class FormattedNumberPipe extends DecimalPipe implements PipeTransform {
	private _localeId: string;
	constructor(private appConfig: AppConfigEnvironmentService)  {
		super('en-US');
		switch (this.appConfig.Environment.SERVER_DATE_LOCATION) {
			case 'it' : {
				this._localeId = 'it-IT';
				break;
			}
			default :{
				this._localeId = 'en-US';
				break;
			}
		}
	}
	transform(value: number, digitsInfo: string = '2.2-2', locale: string = this._localeId): string | null {
		
		if (!value)
			return '0';
			
		return super.transform(value, digitsInfo ,locale);
	}
}
